import { type IconProps } from './IconProps';

const borderedClassNames = 'border-gray-400 border-2 rounded';

// Generic credit card icon (default when card type unknown)
export function GenericCardIcon({ bordered = true, className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} stroke-gray-400 stroke-1 ${bordered ? borderedClassNames : ''}`}
      {...props}
    >
      {/* <rect
        x="1"
        y="1"
        width="30"
        height="22"
        rx="3"
        stroke="#94a3b8"
        strokeWidth="2"
        fill="none"
      /> */}
      <rect x="1" y="5" width="30" height="4" fill="#94a3b8" />
      <rect x="4" y="14" width="8" height="2" rx="1" fill="#94a3b8" />
      <rect x="4" y="18" width="5" height="2" rx="1" fill="#94a3b8" />
    </svg>
  );
}

export default GenericCardIcon;
